import { useTranslation } from "react-i18next";

interface Props {
  isEnding?: boolean;
  text?: string;
  onAction?: () => void;
}

const NoticeBanner = ({ isEnding, text, onAction }: Props) => {
  const { t } = useTranslation();
  const actionText = t("siteManagement.free.beforeApplication.upgradeBtn");
  return (
    <div className={isEnding ? "warningBox" : "noticeBox"}>
      <div>
        {text}
        {isEnding && (
          <b className="mg ml-10">
            <a className="text text--green" href="mailto:cloud@fasoo.com">
              &nbsp;{t("siteManagement.paymentHistory.bill.inquiry")}
            </a>
          </b>
        )}
      </div>

      {actionText &&
        onAction && ( // 유료 전환하기 버튼 (지금은 안쓰는듯!)
          <a className="rightButton" onClick={onAction}>
            <span className="text text--blue">{actionText}</span>
          </a>
        )}
    </div>
  );
};

export default NoticeBanner;
